module.exports = __webpack_public_path__ + "img/frsc.2eb41ce3.png";